<template>
  <div>
    <b-navbar type="dark" variant="utb-blue" fixed="top">
      <b-navbar-brand href="#"><img src="images/logo_utb_blanco.png" alt="Logo"></b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-nav-text>{{ $oauth.data.sub }} {{ $oauth.data.name ? $oauth.data.name : ''}}</b-nav-text>
      </b-navbar-nav>
    </b-navbar>
    <b-container class="mt-3 clear-navbar">
      <h2 class="app-name text-center text-primary">Actualiza UTB</h2>

      <h3 class="text-center">Muchas gracias por actualizar tus datos</h3>
      
      <p v-if="$oauth.data.role === 'VISITANTE'">
        Usted será redirigido a nuestro sistema para que pueda realizar la solicitud de acceso
      </p>
      <p class="text-center mt-2" v-else-if="redirectTo">
        Seras redirigido a {{ redirectTo }} en 5 segundos, o click <a href="" @click.prevent="redirect">aquí</a> para salir inmediatamente
      </p>
    </b-container>
  </div>
</template>

<script lang="ts">
import axios from 'axios'
import { Vue, Component } from 'vue-property-decorator'

import { url } from '../../services/url_service'

@Component
export default class Gracias extends Vue {
  redirectTo: string = ''
  redirect() {
    window.location.assign(this.redirectTo)
  }

  async init() {
    let redirect = (await axios.get(url.create('/session/redirect_to')))?.data
    let self = this
    if (this.$oauth.data.role === 'VISITANTE') {
      setTimeout(function () {
        self.$router.push({ name: 'dashboard' })
      }, 5000)
    } else if (redirect) {
      this.redirectTo = redirect
      setTimeout(function () {
        self.redirect()
      }, 5000)
    }
  }

  created() {
    this.init()
  }
}
</script>

<style>
</style>